import React, { useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { colorGrid } from 's2s-themes';
import styled from 'styled-components';
import Input from 's2s-input';
import Button from 's2s-button';
import { injectIntl } from 'react-intl';
import { getIntlText } from '../js/utilities';

// Styles the Container
const ForgotContainer = styled.div`
    background: ${colorGrid.gray1};
    border-radius: 8px;
    box-shadow: 0px 4px 8px rgba(33, 37, 41, 0.4);
    padding : 8px 0px;
    margin: 0 auto;
    width: 100%;
    max-width: 344px;
    @media(max-width: 376px) {
     width: 90%;
    }
`;
const EmailContainer = styled(Input)`
  width: calc(100% - 48px);
  margin: 16px auto;
`;

const ResetButton = styled(Button)`
  height : 40px;
  margin-right : 16px;
`;

const CancelButton = styled(Button)`
  height : 40px;
  border : 1px solid ${colorGrid.gray3};

  &:hover {
    background-color : ${colorGrid.gray2};
  }
`;

const FooterContainer = styled.div`
  align-items : center;
  display : flex;
  justify-content : space-around;
  margin-top : 24px;
`;

const Forgot = (props) => {
  // console.log('ppppp', props);
  const [forgotValue, setForgotValue] = useState(props.initialValue);
  const buttonRef = useRef(null);

  const handleClick = () => {
    props.cbReset(forgotValue);
  };
  const isInputInvalid = () => !forgotValue;

  const handleInputChange = (inputValue) => {
    setForgotValue(inputValue);
  };

  // Normally, if a user hits enter focus is still left on input. However,
  // this prevents users from seeing the error. Therefore, we put focus on
  // the SIGN IN button to get error message to display.
  const focusButton = () => {
    ReactDOM.findDOMNode(buttonRef.current).focus();
  };

  const handleEnter = () => {
    focusButton();
    props.cbOnEnter(forgotValue);
  };

  return (
    <ForgotContainer className="ForgotContainer">
      <EmailContainer
        className="InputContainer"
        value={forgotValue}
        cbOnChange={handleInputChange}
        cbOnEnter={handleEnter}
        cbOnFocus={props.cbOnEmailFocus}
        errorText={getIntlText(props.intl, 'FORGOT-INPUT-ERROR-TEXT', "Enter a valid email to continue")}
        hasError={props.inputHasError}
        inputLabel={getIntlText(props.intl, 'FORGOT-INPUT-LABEL-TEXT', "Enter your email address to reset your account's password.")}
        svgType="AvatarIconSVG"
        placeholder={getIntlText(props.intl, 'FORGOT-INPUT-PLACEHOLDER-TEXT', "Enter your email...")}
        isDisabled={props.isLoading}
      />
      <FooterContainer>
        <ResetButton
          className="ResetPasswordButton"
          ariaLabel={getIntlText(props.intl, 'FORGOT-RESET-PASSWORD-BUTTON-TEXT', 'RESET PASSWORD')}
          cbClick={handleClick}
          buttonLabel={getIntlText(props.intl, 'FORGOT-RESET-PASSWORD-BUTTON-TEXT', 'RESET PASSWORD')}
          buttonType="primaryGreen"
          isDisabled={props.isLoading || isInputInvalid()}
          ref={buttonRef}
        />
        <CancelButton
          className="CancelButton"
          ariaLabel={getIntlText(props.intl, 'FORGOT-CANCEL-BUTTON-TEXT', 'CANCEL')}
          cbClick={props.cbCancel}
          buttonLabel={getIntlText(props.intl, 'FORGOT-CANCEL-BUTTON-TEXT', 'CANCEL')}
          buttonType="secondary"

        />
      </FooterContainer>
    </ForgotContainer>
  );
};

Forgot.propTypes = {
  cbOnEnter: PropTypes.func,
  cbCancel: PropTypes.func,
  cbOnEmailFocus: PropTypes.func,
  cbReset: PropTypes.func,
  inputHasError: PropTypes.bool,
  intl: PropTypes.object
};

Forgot.defaultProps = {
  cbCancel: () => { console.log('cbCancel default func fired'); },
  cbOnEmailFocus: () => { },
  cbReset: () => { console.log('cbReset default func fired'); },
  inputHasError: false
};

export default injectIntl(Forgot);
